/**
 * Converts given file to base64 string
 * @param {Object} file Input file
 * @returns {Promise<String>} returns promise that resolves with base64 string
 */
export function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      resolve(reader.result.split(",")[1]);
    };
    reader.onerror = err => reject(err);
  });
}
